export default "__VITE_ASSET__DwOKhK5J__"